import "./Testimonials.css";
import TIM from "../../Assets/Images/timSmith.png";
import LEANNA from "../../Assets/Images/leannaLucas.jpg";
import VARMA from "../../Assets/Images/varma.jpg";

// Import Swiper React components
import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";


// import required modules
import { Navigation } from "swiper";

export default class Testimonials extends React.Component {
	render() {
		return (
			<section id="testimonials">
				<h5>Reviews from clients and colleagues</h5>
				<h2>Testimonials</h2>

				<Swiper
        rewind={true}
        navigation={true}
        modules={[Navigation]}
        className="mySwiper"
      >
					<SwiperSlide className="testimonial">
						<div className="testimonial__image">
							<img src={TIM} alt="Tim Smith" />
						</div>

						<h5 className="testimonial__name">Tim Smith</h5>

						<small className="testimonial__review">
							I honestly don't think I've ever met anyone more dedicated to
							becoming the best version of themselves than Munya. He is Human
							2.0. It is my privilege to be his instructor, and to be a part of
							his journey to becoming Human 3.0.
						</small>
					</SwiperSlide>

					{/*  */}
					<SwiperSlide className="testimonial">
						<div className="testimonial__image">
							<img src={LEANNA} alt="Leanna Lucas" />
						</div>

						<h5 className="testimonial__name">Leanna Lucas</h5>

						<small className="testimonial__review">
							Working with Munya has been a pleasure. He is one of the most ambitious and determined developers I've met to date. He puts 100% effort into any project he works on and is always prepared to mentor fellow students and often validates his team mates work. I highly recommend him to anyone looking for a well rounded developer.
						</small>
					</SwiperSlide>

					{/*  */}
					<SwiperSlide className="testimonial">
						<div className="testimonial__image">
							<img src={VARMA} alt="Vatsavaye Priyatham Varma" />
						</div>

						<h5 className="testimonial__name">Vatsavaye Priyatham Varma</h5>

						<small className="testimonial__review">
						Munya is a determined and motivated person who wants to learn constantly. These are the qualities that make him stand apart from the crowd. I would highly recomment him for a tech job. 
						</small>
					</SwiperSlide>
				</Swiper>
			</section>
		);
	}
}
